import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-cumulo',
  standalone: false,
  templateUrl: './cumulo.component.html',
  styleUrl: './cumulo.component.scss'
})

export class CumuloComponent {
  sessionId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();
  }

  volverInicio(): void {
    window.location.href = "https://www.sura.co/";
  }
}
